<div class="body">

    <div class="spacer"></div>

    <div class="label">

        <div class="counter neutral">
            {{state.pending}}
        </div>

        <div class="title">
            Ausstehend
        </div>

    </div>

    <div class="label">

        <div class="counter succeeded">
            {{state.succeeded}}
        </div>

        <div class="title">
            Erfolgreich
        </div>

    </div>

    <div class="label">

        <div class="counter failed">
            {{state.failed}}
        </div>

        <div class="title">
            Fehlgeschlagen
        </div>

    </div>

    <div class="spacer"></div>

</div>